export default __webpack_public_path__ + "static/media/4.bbe55dc2.jpg";